import { takeEvery, put, select } from 'redux-saga/effects'
import { postUpdatedMachineName } from '../../utils/commands'
import { fetchMachines, fetchMachineLogs, fetchOrphanedMachines, fetchMachineOnlineHistory, fetchMachinesWithAlertTypes, PostUtils, fetchMachinesList } from '../../utils/request'
import MachineActionTypes, { FETCH_MACHINES, FETCH_MACHINES_WITH_ALERT_TYPES, FETCH_MACHINE_LOGS, FETCH_MACHINE_ONLINE_HISTORY, FETCH_ORPHANED_MACHINES, RENAME_MACHINE, START_TEST_SEQUENCE, RECIPE_ACTION_MESSAGE_RECEIVED, FETCH_MACHINES_LIST, START_MAINTENANCE_SEQUENCE } from '../actionTypes/machine'



export function* startTestSequenceSaga(action: { type: typeof START_TEST_SEQUENCE; serialId: string }) {
  try {
    yield PostUtils<void>(`device/test-sequence/now?deviceId=${action.serialId}`, undefined );
    
    yield put({ type: 'TEST_SEQUENCE_STARTED', serialId: action.serialId });
  } catch (error) {
    yield put({ 
      type: 'STARTING_TEST_SEQUENCE_FAILED', 
      error: error instanceof Error ? error.message : 'Failed to start test sequence' 
    });
  }
}

export function* startMaintenanceSequenceSaga(action: { type: typeof START_MAINTENANCE_SEQUENCE; serialId: string }) {
  try {
    yield PostUtils<void>(`device/maintenance-sequence/now?deviceId=${action.serialId}`, undefined );
    
    yield put({ type: 'MAINTENANCE_SEQUENCE_STARTED', serialId: action.serialId });
  } catch (error) {
    yield put({ 
      type: 'STARTING_MAINTENANCE_SEQUENCE_FAILED', 
      error: error instanceof Error ? error.message : 'Failed to start maintenance sequence' 
    });
  }
}

const getMachine = (id) => (state) => {
  return state.machines.find(m => m.serialId === id)
}


function* enhanceSalesItem(action: MachineActionTypes) {
  if('RECIPE_ACTION_MESSAGE_RECEIVED' === action.type) {
    const machine = yield select(getMachine(action.message.machineId))
    const storeName = machine?.nodeName ?? 'Unknown'
    yield put({
      type: 'RECIPE_ACTION_MESSAGE_ENHANCED',
      message: {
        timestamp: Date.parse(action.message.timestamp),
        recipe: action.message.recipeType,
        store: storeName,
        recipeAction: action.message.action,
        }
    })
  }
}


export function* machineSagas() {
  yield takeEvery(FETCH_MACHINES, fetchMachines)
  yield takeEvery(FETCH_MACHINES_WITH_ALERT_TYPES, fetchMachinesWithAlertTypes)
  yield takeEvery(FETCH_MACHINE_ONLINE_HISTORY, fetchMachineOnlineHistory)
  // yield takeEvery(FETCH_MACHINE_TWIN, fetchMachineTwin)
  yield takeEvery(FETCH_MACHINE_LOGS, fetchMachineLogs)
  yield takeEvery(FETCH_ORPHANED_MACHINES, fetchOrphanedMachines)
  yield takeEvery(RENAME_MACHINE, postUpdatedMachineName)
  yield takeEvery(START_TEST_SEQUENCE, startTestSequenceSaga)
  yield takeEvery(START_MAINTENANCE_SEQUENCE, startMaintenanceSequenceSaga)
  yield takeEvery(RECIPE_ACTION_MESSAGE_RECEIVED, enhanceSalesItem)
  yield takeEvery(FETCH_MACHINES_LIST, fetchMachinesList)
}